export default "__VITE_ASSET__6cc76130__"